import React from "react";
import { Dashboard } from "../../components/Dashboard/Dashboard";

const HomePage = () => {
    return (<div className="page">
        <Dashboard></Dashboard>
    </div>);
}

export { HomePage };
